// Local
export const SERVER_IP = "https://feda.bupartech.com/wsfeda";

// Feda
// export const SERVER_IP = "https://feda.bupartech.com:8000";